// Full-page navigation seam. window.location.assign is not stubbable in jsdom
// without replacing `location` wholesale, so the auth services route their
// redirects through here and tests mock this module.
export function navigateTo(url: string): void {
  window.location.assign(url)
}
